export const Config = {
  baseAPIUrl: `${process.env.REACT_APP_API_URL}`,
  baseAuthUrl: `${process.env.REACT_APP_AUTH_URL}`,
  docsUrl: "https://riotgames-devrel.zendesk.com/",
  logoutUrl: `${process.env.REACT_APP_AUTH_URL}/logout?client_id=`,
  authClientUrl: `${process.env.REACT_APP_AUTH_URL}/authorize?client_id=`,
  ppCSSChannel: `${process.env.REACT_APP_JIRA_URL}/servicedesk/customer/portal/45`,
};
